import type { ReactElement } from 'react';

import Footer from '@skyscanner-internal/global-components/footer';
import FooterFlags from '@skyscanner-internal/global-components/footer-flags';
import { logError, logOperationalEvent, logWarn } from 'saddlebag-logger';

import CookieBanner from './CookieBanner';
import Header from './Header';
import LegalBanner from './LegalBanner';

import type { GCs } from '@shared/types/global-components';
import type { EntityId, Optional } from '@shared/types/utils';

type Props = {
  gcs: GCs;
  children: ReactElement;
  entityId?: Optional<EntityId>;
  nationId?: Optional<EntityId>;
  isProductionEnv: boolean;
};

const PageSkeleton = ({
  children,
  entityId,
  gcs,
  isProductionEnv,
  nationId,
}: Props) => {
  const props = {
    isProductionEnv,
    logger: { logOperationalEvent, logError, logWarn },
  };

  return (
    <>
      {gcs.cookie_banner ? (
        <CookieBanner
          isProductionEnv={isProductionEnv}
          {...gcs.cookie_banner}
        />
      ) : null}
      {entityId || nationId ? (
        <LegalBanner
          nationId={nationId}
          entityId={entityId}
          isProductionEnv={isProductionEnv}
        />
      ) : null}
      {gcs.header ? (
        <Header {...gcs.header} isProductionEnv={isProductionEnv} />
      ) : null}
      {children}
      {gcs.footer ? <Footer {...gcs.footer} {...props} /> : null}
      {gcs.footer_flags ? (
        <FooterFlags {...gcs.footer_flags} {...props} />
      ) : null}
    </>
  );
};

export default PageSkeleton;
